import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Transition as _Transition, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "operator-application-dialogs"
}
const _hoisted_2 = { class: "pl-2 pt-3 pr-2 sticky -top" }
const _hoisted_3 = {
  class: "text-center",
  key: "buttons",
  style: {"min-height":"3em"}
}
const _hoisted_4 = { class: "p-3" }
const _hoisted_5 = {
  key: 0,
  class: "order-sort-container"
}
const _hoisted_6 = { class: "p-3" }
const _hoisted_7 = {
  key: "search",
  style: {"min-height":"3em"}
}
const _hoisted_8 = {
  key: 0,
  class: "mt-2 p-2 channels-wrapper"
}
const _hoisted_9 = {
  key: 2,
  class: "mt-3 pl-2 pr-2"
}
const _hoisted_10 = {
  key: 3,
  class: "mt-3 pl-2 pr-2 text-muted"
}
const _hoisted_11 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_12 = { class: "pb-2" }
const _hoisted_13 = {
  key: 0,
  class: "sticky -bottom dialog-bottom-button-wrapper pb-2 pt-2"
}
const _hoisted_14 = {
  key: "sync",
  class: "sync-in-progress d-flex p-1 pr-2 pl-2 align-items-center bg-darksea text-white"
}

import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import OperatorApplicationSideMenu from "~/operatorApplication/vue/layout/OperatorApplicationSideMenu.vue";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import Delay from "~/ts/library/Delay";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {BuddyListGroupInterface} from "~/operatorApplication/vue/dialogs/buddyList/group/BuddyListInterface";
import BuddyListGroup from "~/operatorApplication/vue/dialogs/buddyList/group/BuddyListGroup.vue";
import Dictionary from "~/ts/library/Dictionary";
import {__} from "~/ts/library/Translate";
import BuddyListChannelButton from "~/operatorApplication/vue/dialogs/BuddyListChannelButton.vue";
import OperatorBuddyListOrderConfig from "~/operatorApplication/vue/dialogs/OperatorBuddyListOrderConfig.vue";
import ObjectHelper from "~/ts/library/ObjectHelper";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import OpenClientById from "~/operatorApplication/vue/dialogs/OpenClientById.vue";
import WindowHelper from "~/ts/library/WindowHelper";
import OperatorApplicationDialog from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialog.vue";
import {OperatorApplicationDialogsStore} from "~/operatorApplication/ts/store/OperatorApplicationDialogsStore";
import {
    SHORTCUT_NEXT_CHAT,
    SHORTCUT_NEXT_OPENED_CHAT,
    SHORTCUT_NEXT_UNREADED_CHAT,
    SHORTCUT_PREV_CHAT,
    SHORTCUT_PREV_OPENED_CHAT,
    SHORTCUT_PREV_UNREADED_CHAT
} from "~/operatorApplication/ts/service/shortcuts/ShortcutsList";
import {toggleArrayElement} from "~/ts/library/ToggleArrayElement";
import OperatorApplicationSearchDialog from "~/operatorApplication/vue/dialogs/OperatorApplicationSearchDialog.vue";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";
import {OperatorApplicationRoutingStore} from "~/operatorApplication/ts/store/OperatorApplicationRoutingStore";
import {CLIENT_STATUS_OFFLINE} from "~/operatorApplication/ts/data/ClientStatus";
import HiddenBuddyListItem from "~/operatorApplication/vue/dialogs/HiddenBuddyListItem.vue";
import OperatorApplicationMessageStatus from "~/operatorApplication/ts/service/dialog/OperatorApplicationMessageStatus";
import Random from "~/ts/library/Random";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import {isInSelectedSectionInjectionKey} from "~/operatorApplication/vue/layout/OperatorApplicationSectionInjection";
import {makeFilteredList} from "~/ts/vuePlugins/FilteredList";
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import OpenClientByIdExposeInterface from "~/operatorApplication/vue/dialogs/OpenClientByIdExposeInterface";
import OperatorApplicationFinishAllHaveNoAnswerDialog
    from "~/operatorApplication/vue/dialogs/OperatorApplicationFinishAllHaveNoAnswerDialog.vue";
import getCurrentDialogOfClient from "~/operatorApplication/ts/service/buddyList/getCurrentDialogOfClient";
import OperatorApplicationWebRtcCall from "~/operatorApplication/ts/service/webRtc/OperatorApplicationWebRtcCall";
import BuddyListCurrentCall from "~/operatorApplication/vue/dialogs/BuddyListCurrentCall.vue";
import {DropdownInstance} from "element-plus";
import BuddyListCurrentAudio from "~/operatorApplication/vue/dialogs/BuddyListCurrentAudio.vue";
import {nextTick, provide} from "vue";
import {
    CURRENT_DIALOGS_AUDIO_INJECTION_KEY
} from "~/operatorApplication/vue/dialogs/OperatorApplicationDialogsInjection";
import DateHelper from "~/ts/library/Date";
import AbstractPlatformUpdater from "~/operatorApplication/ts/platform/AbstractPlatformUpdater";
import getBuddyListDisplayConfigItems from "~/operatorApplication/ts/service/getBuddyListDisplayConfigItems";
import ServerSideConfigUsedWarning from "~/operatorApplication/vue/config/ServerSideConfigUsedWarning.vue";



import {
    OperatorApplicationEventManager,
    SCROLL_TO_USERNAME_IN_BUDDY_LIST,
    SELECT_OPERATOR_FOR_ANOTHER_OPERATORS_DIALOG,
    UPDATE_ORDER
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {
    AUDIO_MESSAGE_EVENT,
    AudioMessageEventPayloadInterface
} from "~/operatorApplication/vue/dialogs/dialog/DialogChatAreaExposeInterface";
import {computed, inject, onBeforeUnmount, onMounted, ref, watch} from 'vue';


const __default__ = {
    name: "OperatorApplicationDialogs"
}

let currentAudio = ref<AudioMessageEventPayloadInterface>();

OperatorApplicationEventManager.addEventListener(AUDIO_MESSAGE_EVENT, (e: AudioMessageEventPayloadInterface) => {
    currentAudio.value = e.play ? e : null;
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    buddyList: {}
  },
  setup(__props: any) {

const SITE_PLATFORM = "-1";
const CLOSE_OFFLINE_CLIENTS = "closeOfflineClients";
const FINISH_ALL_HAVE_NO_ANSWER = "finishAllHaveNoAnswer";
const MARK_ALL_AS_READED = "markAllAsReaded";

let props = __props

let searchInput = ref<HTMLInputElement>();
let buddyListGroupsDiv = ref<HTMLDivElement>();
let openClientByCc = ref<OpenClientByIdExposeInterface>();

let sortedBuddyList = ref<string[]>([]);
let displayedBuddyList = ref<string[]>([]);
let customListUsernames = ref<string[]>([]);
let selectedUsernameHistory = ref<string[]>([]);
let searchActive = ref(false);
let searchQueryString = ref<string>();
let preparedSearchQueryString = ref<string>();
let selectedChannelId = ref<string>();
let orderConfigShow = ref(false);
let collapsed = ref<Dictionary<boolean>>({});
let fetchCustomListClientsTimeout = ref<any>();
let isFetchCustomListClientsInProgress = ref(false);
let searchDialog = ref(false);
let searchDialogOpenedOnce = ref(false);
let countBySites = ref<Dictionary<number>>({});
let limit = ref<number>(0);
let anotherOperatorDialogOperatorIds = ref<string[]>();
let fetchCustomListClientsId = ref<string>();
let skipHistoryChange = ref(false);
let ccDropdown = ref<DropdownInstance>();
let finishAllHaveNoAnswerDialogVisible = ref(false);

let sites = computed(() => {
    let result = OperatorAccountStore.data.value.sites;
    if (props.buddyList.isCustomSearchList) {
        let siteIds = props.buddyList.customListSearch?.siteIds ?? [];
        if (siteIds.length > 0) {
            result = result.filter(site => siteIds.includes(site.id));
        }
    }
    return result;
});

let allSitesCount = computed(() => {
    let value = 0;
    return ObjectHelper.arrayFromDictionary(countBySites.value).reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        value,
    )
});

provide(CURRENT_DIALOGS_AUDIO_INJECTION_KEY, computed(() => currentAudio.value?.audio));

let selectedUsername = computed({
    get: () => {
        return OperatorApplicationDialogsStore.getSelectedUsername(props.buddyList.id);
    },
    set: (username: string) => {
        OperatorApplicationDialogsStore.setSelectedUsername({buddyListId: props.buddyList.id, username});
    }
});


addDisposableEvent(OperatorApplicationEventManager.addEventListener(
    SELECT_OPERATOR_FOR_ANOTHER_OPERATORS_DIALOG,
    operatorId => {
        if (props.buddyList.isAnotherOperatorBuddyList) {
            anotherOperatorDialogOperatorIds.value = [operatorId];
            fetchCustomListClients(true);
        }
    }
));

let currentCall = computed(() => {
    return OperatorApplicationWebRtcCall.getCurrentCall();
});


function openSearchDialog() {
    searchDialog.value = true;
    searchDialogOpenedOnce.value = true;
}

let syncDescr = computed(() => {
    if (!isCometConnected.value) {
        return __("Соединение");
    } else if (isSyncInProgress.value) {
        return __("Идет синхронизация");
    } else if (isFetchCustomListClientsInProgress.value && !customListUsernames.value.length) {
        return __("Загрузка");
    }
    return null;
});

let sideMenuWidth = computed({
    get: () => {
        return OperatorApplicationConfigInstance.buddyListWidth;
    },
    set: (value: number) => {
        OperatorApplicationConfigInstance.buddyListWidth = value;
    }
});

let isSectionSelected = inject(isInSelectedSectionInjectionKey);
watch(isSectionSelected, () => {
    if (isSectionSelected.value) {
        fetchCustomListClients();
    }
})

let selectedUsernameInSelectedSection = computed(() => {
    return isSectionSelected.value ? selectedUsername.value : null;
});

watch(selectedUsernameInSelectedSection, async () => {
    if (selectedUsernameInSelectedSection.value) {
        await Delay.make(100);
    }
    ClientUserdataStore.setSelectedUsernameInSelectedSection(selectedUsernameInSelectedSection.value);
});

onMounted(() => {
    fetchCustomListClients();
    addDisposableEvent(
        OperatorApplicationEventManager.addEventListener(SCROLL_TO_USERNAME_IN_BUDDY_LIST, (username: string) => {
            if (isSectionSelected.value) {
                scrollToBuddyListItemByUsername(username);
            }
        })
    );
    addDisposableEvent(
        OperatorApplicationEventManager.addEventListener(SHORTCUT_NEXT_CHAT, () => changeSelectedUser(1))
    );
    addDisposableEvent(
        OperatorApplicationEventManager.addEventListener(SHORTCUT_PREV_CHAT, () => changeSelectedUser(-1))
    );
    addDisposableEvent(
        OperatorApplicationEventManager.addEventListener(SHORTCUT_NEXT_UNREADED_CHAT, () => changeSelectedUser(1, true))
    );
    addDisposableEvent(
        OperatorApplicationEventManager.addEventListener(SHORTCUT_PREV_UNREADED_CHAT, () => changeSelectedUser(-1, true))
    );
    addDisposableEvent(
        OperatorApplicationEventManager.addEventListener(SHORTCUT_NEXT_OPENED_CHAT, () => changeSelectedUserByHistory(1))
    );
    addDisposableEvent(
        OperatorApplicationEventManager.addEventListener(SHORTCUT_PREV_OPENED_CHAT, () => changeSelectedUserByHistory(-1))
    );
});

onBeforeUnmount(() => {
    clearTimeout(fetchCustomListClientsTimeout.value);
});

let scrollToMessageIdDictionary: Dictionary<number> = {};

async function fetchCustomListClients(force: boolean = false, silent = true) {
    if (props.buddyList.isCustomSearchList && (!isFetchCustomListClientsInProgress.value || force)) {
        if (force) {
            customListUsernames.value.splice(0, customListUsernames.value.length);
            countBySites.value = {};
        }

        if (OperatorApplicationRoutingStore.isBuddyListSelected(props.buddyList.id)) {
            let fetchId = Random.uid(32);
            fetchCustomListClientsId.value = fetchId;
            clearTimeout(fetchCustomListClientsTimeout.value);
            try {
                if (sites.value.find(site => !site.isFree)) {
                    isFetchCustomListClientsInProgress.value = true;
                    let p: OperatorApplicationApi.OperatorGetCustomBuddyListClientsOpenApiModel = {
                        buddyListId: props.buddyList.id,
                        knownUsernames: customListUsernames.value,
                        selectedUsername: selectedUsername.value
                    };
                    if (props.buddyList.isAnotherOperatorBuddyList) {
                        p.anotherOperatorDialogsBuddyListParams = {
                            operatorIds: anotherOperatorDialogOperatorIds.value
                        };
                    }
                    let result = await (new OperatorApiRequest<OperatorApplicationApi.OperatorGetCustomBuddyListClientsResultOpenApiModel>({
                        url: "/buddyList/getCustomBuddyListClients",
                        p,
                        silent,
                        silentError: true
                    })).send();
                    if (!result.showMessageOnError()) {
                        if (fetchId === fetchCustomListClientsId.value) {
                            let data = result.data;
                            scrollToMessageIdDictionary = data.minMessageId;
                            for (let client of data.add) {
                                ClientUserdataStore.set(client);
                                toggleArrayElement(customListUsernames.value, client.username, true);
                            }
                            for (let username of data.remove) {
                                toggleArrayElement(customListUsernames.value, username, false);
                            }
                            let count: Dictionary<number> = {};
                            for (let item of data.countBySiteId) {
                                count[item.siteId] = item.clientCount;
                            }
                            countBySites.value = count;
                            limit.value = data.limit;
                        }
                    }
                }
            } catch (e) {

            }

            isFetchCustomListClientsInProgress.value = false;
        }
        fetchCustomListClientsTimeout.value = setTimeout(() => {
            fetchCustomListClients();
        }, 20000)

    }
}


function changeSelectedUserByHistory(delta: 1 | -1) {
    if (isSectionSelected.value) {
        skipHistoryChange.value = changeSelectedUserByList(delta, selectedUsernameHistory.value);
    }
}

function changeSelectedUserByList(delta: 1 | -1, usernames: string[]) {
    if (isSectionSelected.value) {
        if (usernames.length) {
            let index = usernames.indexOf(selectedUsername.value) + delta;
            if (index < 0) {
                index = usernames.length - 1;
            } else if (index > usernames.length - 1) {
                index = 0;
            }
            selectedUsername.value = usernames[index];
            scrollToBuddyListItemByUsername(selectedUsername.value);
            return true;
        }
    }
    return false;
}

function changeSelectedUser(delta: 1 | -1, unreadedOnly?: boolean) {
    if (isSectionSelected.value) {
        let usernames: string[] = [];
        for (let group of buddyListGroups.value) {
            usernames.push(...group.getUsernamesMethod());
        }

        usernames = usernames.filter(username => {
            let userdata = ClientUserdataStore.getByUsername(username, false, false);
            let result = false;
            if (userdata) {
                result = !unreadedOnly || userdata.unreadedMessageIds.length > 0;
            }
            return result;
        });

        changeSelectedUserByList(delta, usernames);
    }
}

function clearSelectedUsernameHistory(existedUsernameList: string[]) {
    selectedUsernameHistory.value = selectedUsernameHistory.value.filter(username => existedUsernameList.indexOf(username) > -1);
    let length = selectedUsernameHistory.value.length;
    if (length > 100) {
        selectedUsernameHistory.value.splice(0, length - 100);
    }
}

watch(selectedUsername, () => {
    let username = selectedUsername.value;
    if (!skipHistoryChange.value) {
        if (username) {
            let index = selectedUsernameHistory.value.indexOf(username);
            if (index > -1) {
                selectedUsernameHistory.value.splice(index, 1);
            }
            selectedUsernameHistory.value.push(username);
            clearSelectedUsernameHistory(sortedBuddyList.value);
        }
        skipHistoryChange.value = true;
    }
    if (username) {
        let client = ClientUserdataStore.getByUsername(username, false, false);
        if (client) {
            if (collapsed.value[client.siteId]) {
                collapsed.value[client.siteId] = false;
            }
        }
    }
});


async function showSearch() {
    searchActive.value = true;
    await Delay.make(300);
    if (searchInput.value) {
        searchInput.value.focus();
    }
}

function hideSearch() {
    searchActive.value = false;
    searchQueryString.value = null;
    onSearchStringInput(null);
}


async function onSearchStringInput(newValue: string) {
    try {
        newValue = newValue && newValue.length > 0 ? newValue.toLowerCase() : null;
        await Delay.make(newValue ? 500 : 1, "buddyListSearch");
        preparedSearchQueryString.value = newValue;
    } catch (e) {

    }
}

let groupBySite = computed(() => {
    return props.buddyList.isCrossOperatorsChat ? OperatorApplicationConfigInstance.crossOperatorBuddyListGroupBySites : OperatorApplicationConfigInstance.buddyListGroupBySites;
});

function getClientDialogState(username: string): boolean {
    let userdata = ClientUserdataStore.getByUsername(username, false);
    if (!userdata) {
        return true;
    } else {
        let currentDialog = getCurrentDialogOfClient(userdata);
        let state = OperatorApplicationConfigInstance.buddyListGroupByStateDependsOnOperator ? (!!currentDialog?.isOperatorInDialog && !!currentDialog?.assigned.isAssignedToYou) : !!currentDialog;
        return state || userdata.isHaveNoAnswer;
    }
}

let showCrossOperatorGroups = computed(() => {
    return props.buddyList.isMainBuddyList && OperatorAccountStore.data.value.isShowCrossOperatorGroupsInMainBuddyList;
})

let buddyListGroups = computed(() => {
    let result: BuddyListGroupInterface[] = [];
    let groupByDialogState = props.buddyList.isMainBuddyList && OperatorApplicationConfigInstance.buddyListGroupByState;
    let dialogStates = [true];
    if (groupByDialogState) {
        dialogStates.push(false);
    }
    if (showCrossOperatorGroups.value) {
        if (OperatorAccountStore.data.value.crossOperatorGroups.length > 0) {
            let crossOperatorBuddyList = OperatorAccountStore.data.value.buddyListConfig
                .find(item => item.isCrossOperatorsChat);
            if (crossOperatorBuddyList) {
                result.push({
                    descr: __('Рабочие группы'),
                    dialogState: true,
                    getCountMethod: () => 0,
                    getUsernamesMethod: () => {
                        return OperatorAccountStore.data.value
                            .crossOperatorGroups.map(item => item.chatId)
                            .sort(sortMethod);
                    },
                    id: "crossOperatorGroups",
                    siteId: undefined,
                    operators: [],
                    unavailableBecauseOfFree: false,
                    buddyListOverride: crossOperatorBuddyList
                });
            }
        }
    }
    if (groupBySite.value) {
        if (props.buddyList.isCrossOperatorsChat) {
            if (OperatorAccountStore.data.value.crossOperatorGroups.length > 0) {
                result.push({
                    descr: __('Рабочие группы'),
                    dialogState: true,
                    getCountMethod: () => 0,
                    getUsernamesMethod: () => displayedBuddyList.value.filter(username => !!OperatorAccountStore.crossOperatorChat.value[username]?.group),
                    id: "crossOperatorGroups",
                    siteId: undefined,
                    operators: [],
                    unavailableBecauseOfFree: false
                });
            }
        }

        let groupedSites: Dictionary<OperatorApplicationApi.OperatorGetParamsSiteOpenApiModel[]> = {};
        for (let site of sites.value) {
            let key = OperatorApplicationConfigInstance.buddyListGroupSitesByDomains ? site.domain : site.id;
            if (!groupedSites[key]) {
                groupedSites[key] = [];
            }
            groupedSites[key].push(site);
        }
        let sortedGroupedSites: OperatorApplicationApi.OperatorGetParamsSiteOpenApiModel[][] = [];
        for (let siteGroupKey in groupedSites) {
            if (groupedSites.hasOwnProperty(siteGroupKey)) {
                sortedGroupedSites.push(groupedSites[siteGroupKey]);
            }
        }
        sortedGroupedSites.sort((a, b) => {
            return a[0].weight < b[0].weight ? -1 : 1;
        });

        for (let dialogState of dialogStates) {
            for (let siteGroup of sortedGroupedSites) {
                let site = siteGroup[0];
                let title = site.title;
                if (OperatorApplicationConfigInstance.buddyListGroupSitesByDomains && siteGroup.length > 1) {
                    let languages = siteGroup.map(item => item.languageId).join("/");
                    title = `${site.domain} (${languages})`;
                }
                let unavailableBecauseOfFree = !siteGroup.find(item => !item.isFree) && !props.buddyList.isMainBuddyList;
                result.push({
                    id: `${site.id}_${dialogState}`,
                    descr: title,
                    dialogState: dialogState,
                    siteId: siteGroup.length == 1 ? site.id : null,
                    operators: siteGroup.length == 1 ? site.operators : undefined,
                    unavailableBecauseOfFree,
                    getCountMethod: ((siteGroup: OperatorApplicationApi.OperatorGetParamsSiteOpenApiModel[]) => {
                        return () => {
                            let result = 0;
                            for (let site of siteGroup) {
                                if (site && !site.isFree) {
                                    result += countBySites.value[site.id];
                                }
                            }
                            return result;
                        };
                    })(siteGroup),
                    getUsernamesMethod: ((siteGroup: OperatorApplicationApi.OperatorGetParamsSiteOpenApiModel[]) => {
                        let siteIds: Dictionary<boolean> = {};
                        for (let site of siteGroup) {
                            siteIds[site.id] = true;
                        }
                        return () => {
                            let result: string[] = [];
                            let unknownUsers: string[] = [];
                            let siteIdDictionary = ClientUserdataStore.siteOfUsernames.value;
                            let siteIdDictionaryNonReactive = ClientUserdataStore.siteOfUsernamesNonReactive;
                            for (let username of displayedBuddyList.value) {
                                let siteIdByUsername = siteIdDictionaryNonReactive[username];
                                if (siteIdByUsername === undefined) {
                                    siteIdByUsername = siteIdDictionary[username];
                                }
                                if (siteIdByUsername !== undefined) {
                                    let sameSite: boolean = false;
                                    if (siteIdByUsername == null) {
                                        let chat = OperatorAccountStore.crossOperatorChat.value[username];
                                        if (chat) {
                                            for (let siteId of chat.siteIds) {
                                                if (siteIds[siteId]) {
                                                    sameSite = true;
                                                    break;
                                                }
                                            }
                                        }
                                    } else {
                                        sameSite = siteIds[siteIdByUsername] === true;
                                    }
                                    if (sameSite) {
                                        if (groupByDialogState) {
                                            if (getClientDialogState(username) !== dialogState) {
                                                continue;
                                            }
                                        }
                                        result.push(username);
                                    }
                                } else {
                                    if (!result.length && unknownUsers.length < 3) {
                                        unknownUsers.push(username);
                                    }
                                }

                            }

                            if (result.length || !unknownUsers.length) {
                                return result;
                            } else {
                                return unknownUsers;
                            }
                        }
                    })(siteGroup)
                });
            }
        }
    } else {
        for (let dialogState of dialogStates) {
            let descr = __("Все сайты");
            let hideTitle = !showCrossOperatorGroups.value && !OperatorApplicationConfigInstance.buddyListShowOperators;
            if (groupByDialogState) {
                hideTitle = false;
                descr = dialogState ? __("Активные диалоги") : __("Завершённые диалоги")
            }
            result.push({
                id: `all_${dialogState}`,
                descr: descr,
                dialogState: dialogState,
                getUsernamesMethod: () => {
                    let result = displayedBuddyList.value;
                    if (groupByDialogState) {
                        result = result.filter(username => getClientDialogState(username) == dialogState);
                    }
                    return result;
                },
                operators: OperatorAccountStore.data.value.operators.map(operator => operator.login),
                getCountMethod: () => null,
                unavailableBecauseOfFree: false,
                hideTitle
            });
        }
    }
    return result;
});

let computedChannelId = computed(() => {
    if (channels.value) {
        if (channels.value.find(channel => channel.id === selectedChannelId.value)) {
            return selectedChannelId.value;
        }
    }
    return null;
});

let groupByIntegrationPlatform = computed(() => {
    return props.buddyList.isCrossOperatorsChat ? false : OperatorApplicationConfigInstance.buddyListGroupByIntegrationPlatform;
});

let channels = computed<{ id: string, descr: string, unreaded: number }[]>(() => {
    if (groupByIntegrationPlatform.value) {
        let platforms: Dictionary<string> = {};
        let unreadedCountAll = 0;
        let unreadedCountByPlatform: Dictionary<number> = {};

        for (let username of usernamesList.value) {
            let client = ClientUserdataStore.getByUsername(username, false);
            if (client) {
                let isUnreaded = client.unreadedMessageIds.length > 0;
                let platformId = client.integration ? client.integration.platformId : null;
                if (platformId) {
                    if (!platforms[platformId]) {
                        let platform = OperatorAccountStore.integrationPlatformDictionary.value[platformId];
                        if (platform) {
                            platforms[client.integration.platformId] = platform.descr;
                        }
                    }
                } else {
                    platformId = SITE_PLATFORM;
                    platforms[platformId] = __("Сайт");
                }
                if (isUnreaded) {
                    unreadedCountAll++;
                    if (platformId) {
                        if (!unreadedCountByPlatform.hasOwnProperty(platformId)) {
                            unreadedCountByPlatform[platformId] = 1;
                        } else {
                            unreadedCountByPlatform[platformId]++;
                        }
                    }
                }
            }
        }
        let result: { id: string, descr: string, unreaded: number }[] = [];
        for (let platformId in platforms) {
            if (platforms.hasOwnProperty(platformId)) {
                result.push({
                    id: platformId.length ? platformId : null,
                    descr: platforms[platformId],
                    unreaded: unreadedCountByPlatform[platformId] ?? 0
                });
            }
        }
        result = result.sort((a, b) => {
            if (a.id == SITE_PLATFORM) {
                return -1;
            } else if (b.id == SITE_PLATFORM) {
                return 1;
            } else {
                return a.descr < b.descr ? -1 : 1;
            }
        })
        return result.length > 1 ? [{id: null, descr: __("Все"), unreaded: unreadedCountAll}, ...result] : null;
    } else {
        return null;
    }
});

function getChannelIdByClient(client: CometOperatorApplication.OperatorApplicationClientOpenApiModel) {
    return client.integration ? client.integration.platformId : SITE_PLATFORM;
}

let siteIndexDictionary = computed(() => {
    let result: Dictionary<number> = {};
    let i = 0;
    for (let site of sites.value) {
        result[site.id] = i;
        i++;
    }
    return result;
});

function sortMethod(username1: string, username2: string): number {
    let client1 = ClientUserdataStore.getByUsername(username1, false);
    let client2 = ClientUserdataStore.getByUsername(username2, false);
    if (!client1 && !client2) {
        return 0;
    }
    if (!client1) {
        return 1;
    }
    if (!client2) {
        return -1;
    }
    if (client1.isPinned != client2.isPinned) {
        return client1.isPinned ? -1 : 1;
    }
    if (groupBySite.value) {
        if (client1.siteId != client2.siteId) {
            return siteIndexDictionary.value[client1.siteId] > siteIndexDictionary.value[client2.siteId] ? 1 : -1;
        }
    }
    for (let order of props.buddyList.orderConfig) {
        let field = OperatorAccountStore.orderFieldsDictionary.value[order.fieldId];
        if (field) {
            let value1 = normalizeOrderValue(
                ObjectHelper.getParam(client1, field.path)
            );
            let value2 = normalizeOrderValue(
                ObjectHelper.getParam(client2, field.path)
            );

            if (value1 != value2) {
                let isUndefined1 = value1 == null;
                let isUndefined2 = value2 == null;

                if (!isUndefined1 || !isUndefined2) {
                    if (isUndefined1) {
                        return order.direction;
                    } else if (isUndefined2) {
                        return order.direction * -1;
                    } else {
                        return (value1 < value2 ? 1 : -1) * order.direction;
                    }
                }
            }
        }
    }
    return client1.id > client2.id ? -1 : 1;

    //return 0;
}

/*
function sortUsernames(usernames: string[]) {
    return [...usernames].sort(sortMethod);
}
*/

let crossOperatorsChatUsernames = computed(() => {
    let result = [];
    for (let username in OperatorAccountStore.crossOperatorChat.value) {
        if (OperatorAccountStore.crossOperatorChat.value.hasOwnProperty(username)) {
            result.push(username);
        }
    }
    return result;
});

let nonReactiveSortedBuddyList: string[] = null;
let transactionCount = 0;
let nonReactiveBuddyListChanged = false;

watch(computed(() => props.buddyList.orderConfig), () => {
    sortedBuddyList.value.sort(sortMethod);
}, {
    deep: true
});

function beginChangeBuddyListOrder(): string[] {
    transactionCount++;
    if (nonReactiveSortedBuddyList == null) {
        nonReactiveBuddyListChanged = false;
        nonReactiveSortedBuddyList = [...sortedBuddyList.value];
    }
    return nonReactiveSortedBuddyList;
}

function commitChangeBuddyListOrder(changed: boolean): void {
    if (!nonReactiveBuddyListChanged && changed) {
        nonReactiveBuddyListChanged = changed;
    }
    setTimeout(() => {
        transactionCount--;
        if (transactionCount == 0) {
            if (nonReactiveBuddyListChanged) {
                sortedBuddyList.value = nonReactiveSortedBuddyList;
                nonReactiveSortedBuddyList = null;
                //console.log("commit");
            }
        }
    }, 100);
}

let usernameDictionary: Dictionary<boolean> = {};


let usernamesList = computed(() => {
    let usernames: string[] = [];
    let buddyListConfig = props.buddyList;
    if (buddyListConfig.isMainBuddyList) {
        usernames = OperatorAccountStore.buddyList.value;
    } else if (buddyListConfig.isCustomSearchList) {
        usernames = customListUsernames.value;
    } else if (buddyListConfig.isCrossOperatorsChat) {
        usernames = crossOperatorsChatUsernames.value;
    }

    usernameDictionary = {};
    for (let username of usernames) {
        usernameDictionary[username] = true;
    }

    if (selectedUsername.value) {
        if (!buddyListConfig.isMainBuddyList || !OperatorAccountStore.crossOperatorChat.value[selectedUsername.value]) {
            if (!usernameDictionary[selectedUsername.value]) {
                if (ClientUserdataStore.getByUsername(selectedUsername.value, false)) {
                    usernames = [...usernames, selectedUsername.value];
                    usernameDictionary[selectedUsername.value] = true;
                }
            }
        }
    }

    return usernames;
});

addDisposableEvent(OperatorApplicationEventManager.addEventListener(UPDATE_ORDER, username => {
    //let now = Date.now();
    let buddyList = beginChangeBuddyListOrder();
    let index = buddyList.indexOf(username);
    let changed = false;
    if (index > -1) {
        let newIndex = findInsertIndex(username, buddyList);
        if (newIndex !== index && newIndex !== index + 1) {
            buddyList.splice(index, 1);
            if (newIndex > index) {
                newIndex--;
            }
            buddyList.splice(newIndex, 0, username);
            changed = true;
            //console.log("change order", username, newIndex, index);
        }

        //console.log("elapsed", Date.now() - now, props.buddyList.id, username);
    }
    commitChangeBuddyListOrder(changed);
}));

function findInsertIndex(username: string, buddyList: string[]): number {
    let low = 0;
    let high = buddyList.length;

    let count = 0;

    // Бинарный поиск оптимальной позиции
    while (low < high) {
        count++;
        const mid = Math.floor((low + high) / 2);
        if (sortMethod(buddyList[mid], username) < 0) {
            low = mid + 1;
        } else {
            high = mid;
        }
    }

    return low;
}


watch(usernamesList, (usernames: string[]) => {
    clearSelectedUsernameHistory(usernames);
    let buddyList = beginChangeBuddyListOrder();
    let changed = false;

    let buddyListDictionary: Dictionary<boolean> = {};
    for (let username of buddyList) {
        buddyListDictionary[username] = true;
    }

    for (let i = buddyList.length - 1; i >= 0; i--) {
        let username = buddyList[i];
        if (usernameDictionary[username] !== true) {
            buddyList.splice(i, 1);
            delete buddyListDictionary[username];
            changed = true;
            //console.log("remove old");
        }
    }

    for (let username of usernames) {
        if (!ClientUserdataStore.siteOfUsernames.value.hasOwnProperty(username)) {
            ClientUserdataStore.fetchAndSetUserdata(username);
        }
        if (buddyListDictionary[username] !== true) {
            let index = findInsertIndex(username, buddyList);
            buddyList.splice(index, 0, username);
            delete buddyListDictionary[username];
            changed = true;
            //console.log("insert new");
        }
    }
    commitChangeBuddyListOrder(changed);
}, {immediate: true, deep: true});


/*
function onComputedBuddyListChange(computed: string[], stored: string[]) {
    if (computed.length !== stored.length || JSON.stringify(computed) !== JSON.stringify(stored)) {
        for (let username of computed) {
            if (!stored.includes(username)) {
                stored.push(username);
            }
        }
        for (let index = stored.length - 1; index >= 0; index--) {
            if (!computed.includes(stored[index])) {
                stored.splice(index, 1);
            }
        }
        stored.sort((username1: string, username2: string) => {
            return computed.indexOf(username1) > computed.indexOf(username2) ? 1 : -1;
        });
    }
}
*/

/*
let sortedBuddyListComputed = computed(() => {
    return sortUsernames([...usernamesList.value]);
});



watch(sortedBuddyListComputed, () => {
    onComputedBuddyListChange(sortedBuddyListComputed.value, sortedBuddyList.value);
}, {deep: true})
*/

function normalizeOrderValue(value: any): any {
    if (Array.isArray(value)) {
        value = value.join('|-|');
        //value = value.length ? 1 : 0;
    }
    if (typeof value == "string") {
        value = value.toLowerCase();
    }
    return value;
}

let searchCache = ref<{ query: string, results: Dictionary<boolean> }>();


let displayedBuddyListComputed = computed(() => {
    let channelId = computedChannelId.value;
    let search = preparedSearchQueryString.value;
    let previousSearchCache: Dictionary<boolean> = search && searchCache.value && searchCache.value.query == search ? searchCache.value.results : {};
    if (search) {
        searchCache.value = {
            query: search,
            results: {}
        };
    }
    if (search || channelId) {
        if (displayedBuddyList.value === sortedBuddyList.value) {
            displayedBuddyList.value = [];
        }
        makeFilteredList(sortedBuddyList.value, displayedBuddyList.value, username => {
            let userdata = ClientUserdataStore.getByUsername(username, false);
            if (userdata) {
                if (channelId) {
                    if (channelId != getChannelIdByClient(userdata)) {
                        return false;
                    }
                }
                if (search) {
                    if (typeof previousSearchCache[userdata.hash] == "undefined") {
                        previousSearchCache[userdata.hash] = JSON.stringify(userdata).toLowerCase().indexOf(search) > -1;
                    }
                    if (!previousSearchCache[userdata.hash]) {
                        return false;
                    }
                }
                return true;

            }
            return false;
        }, true);
    } else {
        displayedBuddyList.value = sortedBuddyList.value;
    }

    if (search) {
        searchCache.value.results = previousSearchCache;
    }
    return;
});


watch(displayedBuddyListComputed, () => {
    //this.onComputedBuddyListChange(this.displayedBuddyListComputed, this.displayedBuddyList);
});


let hiddenBuddyList = computed(() => {
    if (sortedBuddyList.value.length != displayedBuddyList.value.length) {
        let _displayedBuddyList: Dictionary<true> = {};
        for (let username of displayedBuddyList.value) {
            _displayedBuddyList[username] = true;
        }
        return sortedBuddyList.value.filter(username => !_displayedBuddyList[username]);
    } else {
        return [];
    }
});


async function goTo(username: string) {
    let client = ClientUserdataStore.getByUsername(username);
    if (client) {
        if (collapsed.value[client.siteId]) {
            collapsed.value[client.siteId] = false;
            await Delay.make(100);
        }
    }
    OperatorApplicationBuddyList.addClientAndOpenByUsername(username);
}

async function scrollToBuddyListItemByUsername(username: string) {
    let item = getBuddyListItemByUsername(username);
    if (item) {
        await Delay.make(50);

        //Ждем чуток из-за того, что скролл прерывается на действии пользвателя
        WindowHelper.scrollToElement(item, buddyListGroupsDiv.value, 0, buddyListGroupsDiv.value.offsetHeight / -2 - item.clientHeight);
    }
}

function getBuddyListItemByUsername(username: string): HTMLDivElement {
    return buddyListGroupsDiv.value.querySelector(`.buddy-list-item-${username}`);
}

let unreadedUsernames = computed(() => {
    return displayedBuddyList.value.filter(username => {
        let client = ClientUserdataStore.getByUsername(username, false);
        return client && (client.unreadedMessageIds.length || client.messagesWithUnreadedState.length);
    });
});

let haveNoAnswerUsernames = computed(() => {
    return displayedBuddyList.value.filter(username => {
        let client = ClientUserdataStore.getByUsername(username, false);
        return client && client.isHaveNoAnswer;
    });
});

function getNextUsernameInList(list: string[]) {
    if (list.length) {
        let username = selectedUsername.value;
        let selectedIndex = username ? list.indexOf(username) : -1;
        let index: number;
        if (selectedIndex == -1) {
            index = 0;
        } else {
            index = selectedIndex + 1;
            if (!list[index]) {
                index = 0;
            }
            if (list[index] == username) {
                index = -1;
            }
        }
        if (index > -1) {
            return list[index];
        }
    }
    return null;
}

let returnClosedClientSeconds = computed(() => {
    if (props.buddyList.isMainBuddyList) {
        let lastRemovedClient = OperatorApplicationBuddyList.lastRemovedClient.value;
        if (lastRemovedClient) {

            let time = lastRemovedClient.time;
            let username = lastRemovedClient.username;

            let timeout = 7;
            let delta = parseInt(((DateHelper.nowEverySecond - time) / 1000).toFixed(1));
            if (delta <= timeout) {
                if (!sortedBuddyList.value.includes(username)) {
                    return timeout - delta;
                }
            } else {
                OperatorApplicationBuddyList.lastRemovedClient.value = null;
            }
        }
    }
    return null;
})


let nextUnreadedUsername = computed(() => {
    return getNextUsernameInList(unreadedUsernames.value);
});

let nextHaveNoAnswerUsername = computed(() => {
    return getNextUsernameInList(haveNoAnswerUsernames.value);
});

let isServerSideConfigUsed = computed(() => {
    return !!OperatorAccountStore.isServerSideSettings && !props.buddyList.isCrossOperatorsChat;
});

let buddyListConfigItems = computed(() => {
    return props.buddyList.isCrossOperatorsChat ? OperatorApplicationConfigInstance.crossOperatorBuddyListDisplayConfigItems : getBuddyListDisplayConfigItems(OperatorApplicationConfigInstance);
});

let isSyncInProgress = computed(() => {
    return ClientUserdataStore.isLoading.value || OperatorAccountStore.isOperatorParamsLoading.value;
});

let isCometConnected = OperatorAccountStore.isCometConnected;

let newBuddyListOrderConfig = ref<OperatorApplicationApi.OperatorBuddyListConfigOrderOpenApiModel[]>();

function onBuddyListOrderUpdate(value: OperatorApplicationApi.OperatorBuddyListConfigOrderOpenApiModel[]) {
    newBuddyListOrderConfig.value = value;
}

async function onBuddyListOrderConfigVisibleChange(value: boolean) {
    orderConfigShow.value = value;
    if (value) {
        newBuddyListOrderConfig.value = null;
    } else {
        let newConfig = newBuddyListOrderConfig.value;
        if (newConfig) {
            props.buddyList.orderConfig = ObjectHelper.jsonClone(newBuddyListOrderConfig.value);
            let p: OperatorApplicationApi.OperatorSaveBuddyListOrderConfigOpenApiModel = {
                id: props.buddyList.id,
                config: newConfig
            };

            (await (new OperatorApiRequest({
                url: "/buddyList/saveBuddyListOrderConfig",
                p,
                silent: true
            })).send()).showMessageOnError();
        }
    }
}


function onOpenByCcOpen() {
    if (openClientByCc.value) {
        openClientByCc.value.focusInput();
    }
}

let otherCommandsDropdown = computed(() => {
    let result: { label: string, command: string, disabled?: boolean }[] = [];
    if (props.buddyList.isMainBuddyList) {
        result.push(...[
            {label: __("Убрать из списка всех клиентов не в сети"), command: CLOSE_OFFLINE_CLIENTS},
            {label: __("Завершить все Offline вопросы"), command: FINISH_ALL_HAVE_NO_ANSWER}
        ]);
    }
    result.push({label: __("Пометить все прочитанным"), command: MARK_ALL_AS_READED})
    return result;
});

function onOtherCommand(command: string) {
    if (command == CLOSE_OFFLINE_CLIENTS) {
        closeOfflineClients();
    } else if (command == FINISH_ALL_HAVE_NO_ANSWER) {
        finishAllHaveNoAnswerDialogVisible.value = true;
    } else if (command == MARK_ALL_AS_READED) {
        markAllAsReaded();
    }
}

async function markAllAsReaded() {
    for (let username of sortedBuddyList.value) {
        let client = ClientUserdataStore.getByUsername(username, false);
        if (client.unreadedMessageIds.length && client.lastMessage) {
            OperatorApplicationMessageStatus.setMessageStatusReaded(client, client.lastMessage);
        }
    }
}

async function closeOfflineClients() {
    try {
        await ElConfirm(__("Вы хотите закрыть все чаты с посетителями, которые ушли с Вашего сайта?"));
        let usernames = [];
        for (let username of sortedBuddyList.value) {
            let client = ClientUserdataStore.getByUsername(username, false);
            if (client && client.status === CLIENT_STATUS_OFFLINE && !client.isHaveNoAnswer && !client.isPinned) {
                usernames.push(username);
            }
        }
        if (usernames.length) {
            OperatorApplicationBuddyList.removeClients(usernames);
        }
    } catch (e) {

    }
}

let emptyBuddyListPlaceholder = computed(() => {
    return props.buddyList.isOnlineClientsList ? __('Сейчас на сайте нет ни одного юзера') : __('Пока что нe было ни одной беседы');
});

let operators = computed(() => {
    return OperatorAccountStore.data.value.operators
        .map(operator => ({
            id: operator.id,
            descr: OperatorAccountStore.data.value.accessRights.canViewOperatorsLogin ? `${operator.fio} (${operator.login})` : operator.fio
        }));
});

function onSelectUsername(username: string) {
    selectedUsername.value = username;
    let messageId = scrollToMessageIdDictionary[username];
    if (messageId) {
        nextTick(() => {
            OperatorApplicationBuddyList.scrollToDialogId(username, null, messageId);
        });
    }

}

function onCurrentAudioEnded(e: AudioMessageEventPayloadInterface) {
    if (e == currentAudio.value) {
        currentAudio.value = null;
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (__props.buddyList)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(OperatorApplicationSideMenu, {
          style: {"overflow":"hidden !important"},
          width: _unref(sideMenuWidth),
          "onUpdate:width": _cache[8] || (_cache[8] = ($event: any) => (_isRef(sideMenuWidth) ? (sideMenuWidth).value = $event : sideMenuWidth = $event)),
          "min-width": 257,
          "max-width": 500,
          class: _normalizeClass({
                'buddy-list-side-menu d-flex flex-column position-relative': true,
                'has-selected-user': !!_unref(selectedUsername)
            })
        }, {
          default: _withCtx(() => [
            (_unref(currentCall))
              ? (_openBlock(), _createBlock(BuddyListCurrentCall, {
                  key: 0,
                  call: _unref(currentCall)
                }, null, 8, ["call"]))
              : _createCommentVNode("", true),
            (_unref(currentAudio))
              ? (_openBlock(), _createBlock(BuddyListCurrentAudio, {
                  key: _unref(currentAudio).key,
                  e: _unref(currentAudio),
                  onEnded: onCurrentAudioEnded
                }, null, 8, ["e"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_Transition, {
                name: "zoom",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (!_unref(searchActive))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (__props.buddyList.isSystem)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              circle: "",
                              plain: "",
                              type: "info",
                              class: "buddy-list-top-button",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (openSearchDialog()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(FontAwesomeIcon, { icon: "search" })
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              circle: "",
                              plain: "",
                              type: "info",
                              class: "buddy-list-top-button",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (openSearchDialog()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(FontAwesomeIcon, { icon: "users-cog" })
                              ]),
                              _: 1
                            })),
                        (_unref(searchDialogOpenedOnce))
                          ? (_openBlock(), _createBlock(OperatorApplicationSearchDialog, {
                              key: 2,
                              visible: _unref(searchDialog),
                              "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_isRef(searchDialog) ? (searchDialog).value = $event : searchDialog = $event)),
                              "buddy-list": __props.buddyList,
                              onReloadCustomList: fetchCustomListClients
                            }, null, 8, ["visible", "buddy-list"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_dropdown, {
                          trigger: "click",
                          ref_key: "ccDropdown",
                          ref: ccDropdown,
                          class: "m-0"
                        }, {
                          dropdown: _withCtx(() => [
                            _createVNode(_component_el_dropdown_menu, null, {
                              default: _withCtx(() => [
                                _createVNode(OpenClientById, {
                                  onClose: _cache[3] || (_cache[3] = ($event: any) => (_unref(ccDropdown).handleClose())),
                                  ref_key: "openClientByCc",
                                  ref: openClientByCc
                                }, null, 512)
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              circle: "",
                              plain: "",
                              type: "info",
                              class: "buddy-list-top-button",
                              onClick: onOpenByCcOpen
                            }, {
                              default: _withCtx(() => [
                                _createVNode(FontAwesomeIcon, { icon: "hashtag" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512),
                        _createVNode(_component_el_button, {
                          onClick: showSearch,
                          circle: "",
                          plain: "",
                          type: "info",
                          class: "buddy-list-top-button"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(FontAwesomeIcon, { icon: "filter" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown, { trigger: "click" }, {
                          dropdown: _withCtx(() => [
                            _createVNode(_component_el_dropdown_menu, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                  (_unref(isServerSideConfigUsed))
                                    ? (_openBlock(), _createBlock(ServerSideConfigUsedWarning, {
                                        key: 0,
                                        class: "mb-4"
                                      }))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("h4", null, _toDisplayString(_unref(__)("Список контактов")), 1)
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(buddyListConfigItems), (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: item.descr,
                                      class: "mt-3"
                                    }, [
                                      _createVNode(_component_el_switch, {
                                        disabled: _unref(isServerSideConfigUsed),
                                        "model-value": item.getter(),
                                        "onUpdate:modelValue": item.setter,
                                        class: "mr-2"
                                      }, null, 8, ["disabled", "model-value", "onUpdate:modelValue"]),
                                      _createTextVNode(" " + _toDisplayString(item.descr), 1)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              circle: "",
                              plain: "",
                              type: "info",
                              class: "buddy-list-top-button"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(FontAwesomeIcon, { icon: "list" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown, {
                          trigger: "click",
                          onVisibleChange: onBuddyListOrderConfigVisibleChange
                        }, {
                          dropdown: _withCtx(() => [
                            _createVNode(_component_el_dropdown_menu, null, {
                              default: _withCtx(() => [
                                (_unref(orderConfigShow))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                      _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("h4", null, _toDisplayString(_unref(__)("Сортировка")), 1)
                                        ]),
                                        _createVNode(OperatorBuddyListOrderConfig, {
                                          "buddy-list-order-fields": _unref(OperatorAccountStore).data.value.buddyListOrderFields,
                                          "order-config": __props.buddyList.orderConfig,
                                          "is-server-side": _unref(OperatorAccountStore).isServerSideSettings && __props.buddyList.isMainBuddyList,
                                          onUpdate: onBuddyListOrderUpdate
                                        }, null, 8, ["buddy-list-order-fields", "order-config", "is-server-side"])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              circle: "",
                              plain: "",
                              type: "info",
                              class: "buddy-list-top-button"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(FontAwesomeIcon, { icon: "sort-alpha-down" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_unref(otherCommandsDropdown).length)
                          ? (_openBlock(), _createBlock(_component_el_dropdown, {
                              key: 3,
                              trigger: "click",
                              onCommand: onOtherCommand
                            }, {
                              dropdown: _withCtx(() => [
                                _createVNode(_component_el_dropdown_menu, null, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(otherCommandsDropdown), (item) => {
                                      return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                        key: item.command,
                                        command: item.command,
                                        disabled: item.disabled
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.label), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["command", "disabled"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  circle: "",
                                  plain: "",
                                  type: "info",
                                  class: "buddy-list-top-button"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(FontAwesomeIcon, { icon: "ellipsis-h" })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_el_input, {
                          ref_key: "searchInput",
                          ref: searchInput,
                          modelValue: _unref(searchQueryString),
                          "onUpdate:modelValue": [
                            _cache[4] || (_cache[4] = ($event: any) => (_isRef(searchQueryString) ? (searchQueryString).value = $event : searchQueryString = $event)),
                            onSearchStringInput
                          ],
                          class: "search-input",
                          placeholder: `${_unref(__)('Поиск по открытым чатам')}...`
                        }, {
                          suffix: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              onClick: hideSearch,
                              link: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(FontAwesomeIcon, { icon: "times" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]))
                ]),
                _: 1
              }),
              (_unref(channels))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(channels), (channel) => {
                      return (_openBlock(), _createBlock(BuddyListChannelButton, {
                        key: channel.id,
                        descr: channel.descr,
                        selected: channel.id === _unref(computedChannelId),
                        onClick: ($event: any) => (_isRef(selectedChannelId) //@ts-ignore
 ? selectedChannelId.value = channel.id : selectedChannelId = channel.id),
                        "unreaded-count": channel.unreaded
                      }, null, 8, ["descr", "selected", "onClick", "unreaded-count"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (__props.buddyList.isAnotherOperatorBuddyList)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(anotherOperatorDialogOperatorIds),
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(anotherOperatorDialogOperatorIds) ? (anotherOperatorDialogOperatorIds).value = $event : anotherOperatorDialogOperatorIds = $event)),
                    multiple: "",
                    placeholder: _unref(__)('Все операторы'),
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (fetchCustomListClients(true))),
                    class: "w-100 operators-select",
                    filterable: "",
                    "default-first-option": ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operators), (operator) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: operator.id,
                          value: operator.id,
                          label: operator.descr
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]))
              : _createCommentVNode("", true),
            (_unref(limit) && _unref(allSitesCount))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_unref(__)("Всего чатов")) + ": " + _toDisplayString(_unref(allSitesCount)) + " ", 1),
                  (_unref(limit) < _unref(allSitesCount))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(__)("Показано %d чатов", _unref(limit))), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "user-select-none pl-2 flex-fill buddy-list mt-3",
              ref_key: "buddyListGroupsDiv",
              ref: buddyListGroupsDiv
            }, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(buddyListGroups), (group) => {
                  return (_openBlock(), _createBlock(BuddyListGroup, {
                    key: group.id,
                    "scroll-container": _unref(buddyListGroupsDiv),
                    "is-filter-mode-enabled": _unref(buddyListGroups).length > 0 && _unref(preparedSearchQueryString) != null && _unref(searchActive),
                    collapsed: _unref(collapsed)[group.id],
                    "onUpdate:collapsed": ($event: any) => ((_unref(collapsed)[group.id]) = $event),
                    group: group,
                    "empty-placeholder": _unref(emptyBuddyListPlaceholder),
                    "selected-username": _unref(selectedUsername),
                    onSelect: onSelectUsername,
                    "buddy-list": group.buddyListOverride ?? __props.buddyList,
                    "unavailable-because-of-free": group.unavailableBecauseOfFree,
                    "selected-operator-ids": _unref(anotherOperatorDialogOperatorIds),
                    onReload: _cache[7] || (_cache[7] = ($event: any) => (fetchCustomListClients(false, $event)))
                  }, null, 8, ["scroll-container", "is-filter-mode-enabled", "collapsed", "onUpdate:collapsed", "group", "empty-placeholder", "selected-username", "buddy-list", "unavailable-because-of-free", "selected-operator-ids"]))
                }), 128))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hiddenBuddyList), (username) => {
                return (_openBlock(), _createBlock(HiddenBuddyListItem, {
                  key: username,
                  "buddy-list": __props.buddyList,
                  username: username
                }, null, 8, ["buddy-list", "username"]))
              }), 128)),
              (_unref(nextUnreadedUsername) || _unref(nextHaveNoAnswerUsername) || _unref(returnClosedClientSeconds) || _unref(AbstractPlatformUpdater).applyUpdateFunction.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_unref(returnClosedClientSeconds))
                      ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          round: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(FontAwesomeIcon, {
                              class: "mr-1",
                              icon: "rotate-left"
                            }),
                            _createTextVNode(" " + _toDisplayString(_unref(__)("Отменить закрытие чата")) + " ", 1),
                            _createVNode(_component_el_tag, { type: "info" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(returnClosedClientSeconds)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })), [
                          [_directive_on_native, () => { goTo(_unref(OperatorApplicationBuddyList).lastRemovedClient.value.username); _unref(OperatorApplicationBuddyList).lastRemovedClient.value = null; }, "click"]
                        ])
                      : _createCommentVNode("", true),
                    (_unref(nextUnreadedUsername))
                      ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                          type: "primary",
                          key: "unreaded",
                          round: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(__)("Следующее непрочитанное")), 1)
                          ]),
                          _: 1
                        })), [
                          [_directive_on_native, () => goTo(_unref(nextUnreadedUsername)), "click"]
                        ])
                      : _createCommentVNode("", true),
                    (_unref(nextHaveNoAnswerUsername))
                      ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                          key: "haveNoAnswer",
                          round: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(FontAwesomeIcon, {
                              icon: "question-circle",
                              class: "text-danger mr-1"
                            }),
                            _createTextVNode(" " + _toDisplayString(_unref(__)("Следующий Offline-вопрос")), 1)
                          ]),
                          _: 1
                        })), [
                          [_directive_on_native, () => goTo(_unref(nextHaveNoAnswerUsername)), "click"]
                        ])
                      : _createCommentVNode("", true),
                    (_unref(AbstractPlatformUpdater).applyUpdateFunction.value)
                      ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                          key: "updateApp",
                          round: "",
                          type: "success"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(__)("Обновить приложение")), 1)
                          ]),
                          _: 1
                        })), [
                          [_directive_on_native, _unref(AbstractPlatformUpdater).applyUpdateFunction.value, "click"]
                        ])
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 512),
            _createElementVNode("div", null, [
              (_unref(syncDescr))
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(FontAwesomeIcon, {
                      class: "fa-spin mr-2",
                      style: {"font-size":"2em","opacity":".8"},
                      icon: "circle-notch",
                      light: ""
                    }),
                    _createElementVNode("span", null, _toDisplayString(_unref(syncDescr)) + "... ", 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["width", "class"]),
        (_unref(selectedUsername))
          ? (_openBlock(), _createBlock(OperatorApplicationDialog, {
              key: 0,
              class: "flex-fill overflow-auto",
              username: _unref(selectedUsername),
              "buddy-list": __props.buddyList
            }, null, 8, ["username", "buddy-list"]))
          : _createCommentVNode("", true),
        (_unref(finishAllHaveNoAnswerDialogVisible))
          ? (_openBlock(), _createBlock(OperatorApplicationFinishAllHaveNoAnswerDialog, {
              key: 1,
              visible: _unref(finishAllHaveNoAnswerDialogVisible),
              "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_isRef(finishAllHaveNoAnswerDialogVisible) ? (finishAllHaveNoAnswerDialogVisible).value = $event : finishAllHaveNoAnswerDialogVisible = $event))
            }, null, 8, ["visible"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})